<template>
    <div :data-ref="`adverse-event-form-${adverseEvent.id}`">
        <v-col cols="12" xl="10">
            <b-alert
                v-if="adverseEvent.id === 'new'"
                :message="t('patients::adverse-event-form.create.message')"
            ></b-alert>
        </v-col>
        <v-col cols="12" xl="10">
            <v-form ref="detailsForm" v-model="adverseEventDetailsForm">
                <v-row>
                    <v-col cols="12" class="pb-0">
                        <h5>{{ t('patients::adverse_event.form.title.event_type') }}</h5>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-select
                            to-mutate="adverse_event::adverse_event.event_type"
                            :label="t('patients::adverse_event.form.label.event_type')"
                            :select-items="adverseEventTypesSelectItems"
                            :rules="validationRules.adverse_event_type"
                            :readonly="adverseEvent.reporting_type === 'automatic'"
                            :clearable="false"
                            mandatory
                        ></b-select>
                    </v-col>
                    <v-col v-if="adverseEvent.id === 'new'" cols="12" lg="4" class="pb-0 pr-lg-10">
                        <v-btn class="mt-5" small rounded color="primary" @click="createAdverseEvent">Save</v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-col>
        <v-col cols="12" xl="10">
            <v-form ref="form" v-model="adverseEventForm">
                <v-row class="pb-6">
                    <v-col cols="12" class="pb-0">
                        <h5>{{ t('patients::adverse_event.form.title.reporters') }}</h5>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.reporter_name"
                            :label="t('patients::adverse_event.form.label.reporters.name')"
                            :rules="validationRules.reporter_name"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.reporter_address"
                            :label="t('patients::adverse_event.form.label.reporters.address')"
                            :rules="validationRules.reporter_address"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-select
                            to-mutate="adverse_event::adverse_event.pdf_data.reporter_type"
                            :label="t('patients::adverse_event.form.label.reporters.type')"
                            :select-items="reportersTypeSelectItems"
                            :rules="validationRules.reporter_type"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-select>
                    </v-col>
                </v-row>

                <v-row class="pb-6">
                    <v-col cols="12" class="pb-0">
                        <h5>{{ t('patients::adverse_event.form.title.patient') }}</h5>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.patient_initials"
                            :label="t('patients::adverse_event.form.label.patient.initials')"
                            :rules="validationRules.patient_initials"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-date-picker-store
                            to-mutate="adverse_event::adverse_event.pdf_data.patient_dob"
                            :label="t('patients::adverse_event.form.label.patient.dob')"
                            ::rules="validationRules.patient_dob"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-date-picker-store>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-select
                            to-mutate="adverse_event::adverse_event.pdf_data.patient_gender"
                            :label="t('patients::adverse_event.form.label.patient.gender')"
                            :select-items="genderSelectItems"
                            :rules="validationRules.patient_gender"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-select>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.patient_dms_id"
                            :label="t('patients::adverse_event.form.label.patient.dms_id')"
                            :rules="validationRules.patient_dms_id"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.patient_age"
                            :label="t('patients::adverse_event.form.label.patient.age')"
                            :rules="validationRules.patient_age"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-input>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" class="pb-0">
                        <h5>{{ t('patients::adverse_event.form.title.company') }}</h5>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.company_product"
                            :label="t('patients::adverse_event.form.label.company.product')"
                            :rules="validationRules.company_product"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-switch
                            to-mutate="adverse_event::adverse_event.pdf_data.company_product_taken"
                            :label="t('patients::adverse_event.form.label.company.product_taken')"
                            :readonly="readOnlyRules"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-switch
                            to-mutate="adverse_event::adverse_event.pdf_data.company_suspected_as_possible_cause_of_events"
                            :label="
                                t('patients::adverse_event.form.label.company.suspected_as_possible_cause_of_events')
                            "
                            :readonly="readOnlyRules"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.company_indication_diagnosis"
                            :label="t('patients::adverse_event.form.label.company.indication_diagnosis')"
                            :rules="validationRules.company_indication_diagnosis"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.company_dose_route"
                            :label="t('patients::adverse_event.form.label.company.dose_route')"
                            :rules="validationRules.company_dose_route"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-input>
                    </v-col>
                </v-row>
                <v-row class="pb-6">
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-date-picker-store
                            to-mutate="adverse_event::adverse_event.pdf_data.company_start_date"
                            :label="t('patients::adverse_event.form.label.company.start_date')"
                            :readonly="readOnlyRules"
                        ></b-date-picker-store>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-date-picker-store
                            to-mutate="adverse_event::adverse_event.pdf_data.company_stop_date"
                            :label="t('patients::adverse_event.form.label.company.stop_date')"
                            :readonly="readOnlyRules"
                        ></b-date-picker-store>
                    </v-col>
                </v-row>

                <v-row class="pb-6">
                    <v-col cols="12" class="pb-0">
                        <h5>{{ t('patients::adverse_event.form.title.other_safety') }}</h5>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-switch
                            to-mutate="adverse_event::adverse_event.pdf_data.safety_off_label_indication"
                            :label="t('patients::adverse_event.form.label.other_safety.off_label_indication')"
                            :readonly="readOnlyRules"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-switch
                            to-mutate="adverse_event::adverse_event.pdf_data.safety_drug_indication"
                            :label="t('patients::adverse_event.form.label.other_safety.drug_indication')"
                            :readonly="readOnlyRules"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-switch
                            to-mutate="adverse_event::adverse_event.pdf_data.safety_exposure_during_pregnancy"
                            :label="t('patients::adverse_event.form.label.other_safety.exposure_during_pregnancy')"
                            :readonly="readOnlyRules"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-switch
                            to-mutate="adverse_event::adverse_event.pdf_data.safety_lack_of_efficacy"
                            :label="t('patients::adverse_event.form.label.other_safety.lack_of_efficacy')"
                            :readonly="readOnlyRules"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-switch
                            to-mutate="adverse_event::adverse_event.pdf_data.safety_misuse_abuse"
                            :label="t('patients::adverse_event.form.label.other_safety.misuse_abuse')"
                            :readonly="readOnlyRules"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-switch
                            to-mutate="adverse_event::adverse_event.pdf_data.safety_medication_prescription_error"
                            :label="t('patients::adverse_event.form.label.other_safety.medication_prescription_error')"
                            :readonly="readOnlyRules"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-switch
                            to-mutate="adverse_event::adverse_event.pdf_data.safety_overdose"
                            :label="t('patients::adverse_event.form.label.other_safety.overdose')"
                            :readonly="readOnlyRules"
                        ></b-switch>
                    </v-col>
                </v-row>

                <v-row class="pb-6">
                    <v-col cols="12" class="pb-0">
                        <h5>{{ t('patients::adverse_event.form.title.other_medication') }}</h5>
                    </v-col>
                    <v-col cols="12" lg="12" class="pb-0 pr-lg-10">
                        <b-textarea
                            to-mutate="adverse_event::adverse_event.pdf_data.other_products"
                            :label="t('patients::adverse_event.form.label.other.products')"
                            :readonly="readOnlyRules"
                            rows="3"
                        ></b-textarea>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" class="pb-0">
                        <h5>{{ t('patients::adverse_event.form.title.adverse_event') }}</h5>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-date-picker-store
                            to-mutate="adverse_event::adverse_event.pdf_data.adverse_event_date_event_started"
                            :label="t('patients::adverse_event.form.label.adverse_event.date_event_started')"
                            :rules="validationRules.adverse_event_date_event_started"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-date-picker-store>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-date-picker-store
                            to-mutate="adverse_event::adverse_event.pdf_data.adverse_event_date_event_stopped"
                            :label="t('patients::adverse_event.form.label.adverse_event.date_event_stopped')"
                            :rules="validationRules.adverse_event_date_event_stopped"
                            :readonly="readOnlyRules"
                        ></b-date-picker-store>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-select
                            to-mutate="adverse_event::adverse_event.pdf_data.adverse_event_seriousness_criteria"
                            :label="t('patients::adverse_event.form.label.adverse_event.seriousness_criteria')"
                            :select-items="seriousnessCriteriaSelectItems"
                            :rules="validationRules.adverse_event_seriousness_criteria"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-select>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-select
                            to-mutate="adverse_event::adverse_event.pdf_data.adverse_event_treatment_required"
                            :label="t('patients::adverse_event.form.label.adverse_event.treatment_required')"
                            :select-items="treatmentSelectItems"
                            :rules="validationRules.adverse_event_treatment_required"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-select>
                    </v-col>
                </v-row>
                <v-row class="pb-6">
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-switch
                            to-mutate="adverse_event::adverse_event.pdf_data.adverse_event_continuing"
                            :label="t('patients::adverse_event.form.label.adverse_event.continuing')"
                            :readonly="readOnlyRules"
                        ></b-switch>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-switch
                            to-mutate="adverse_event::adverse_event.pdf_data.adverse_event_seriousness"
                            :label="t('patients::adverse_event.form.label.adverse_event.seriousness')"
                            :readonly="readOnlyRules"
                        ></b-switch>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" class="pb-0">
                        <h5>{{ t('patients::adverse_event.form.title.description') }}</h5>
                    </v-col>
                    <v-col cols="12" lg="6" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.description_decreased_white_blood_cell_count_of"
                            :label="
                                t('patients::adverse_event.form.label.description.decreased_white_blood_cell_count_of')
                            "
                            :rules="validationRules.description_decreased_white_blood_cell_count_of"
                            :readonly="readOnlyRules"
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.description_decreased_white_blood_cell_count_of_value"
                            :label="
                                t(
                                    'patients::adverse_event.form.label.description.decreased_white_blood_cell_count_of_value'
                                )
                            "
                            :rules="validationRules.description_decreased_white_blood_cell_count_of_value"
                            :readonly="readOnlyRules"
                        ></b-input>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" lg="6" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.description_decreased_neutrophil_count_of"
                            :label="t('patients::adverse_event.form.label.description.decreased_neutrophil_count_of')"
                            :rules="validationRules.description_decreased_neutrophil_count_of"
                            :readonly="readOnlyRules"
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.description_decreased_neutrophil_count_of_value"
                            :label="
                                t('patients::adverse_event.form.label.description.decreased_neutrophil_count_of_value')
                            "
                            :rules="validationRules.description_decreased_neutrophil_count_of_value"
                            :readonly="readOnlyRules"
                        ></b-input>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" lg="6" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.description_decreased_platelets_count_of"
                            :label="t('patients::adverse_event.form.label.description.decreased_platelets_count_of')"
                            :rules="validationRules.description_decreased_platelets_count_of"
                            :readonly="readOnlyRules"
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.description_decreased_platelets_count_of_value"
                            :label="
                                t('patients::adverse_event.form.label.description.decreased_platelets_count_of_value')
                            "
                            :rules="validationRules.description_decreased_platelets_count_of_value"
                            :readonly="readOnlyRules"
                        ></b-input>
                    </v-col>
                </v-row>
                <v-row class="pb-6">
                    <v-col cols="12" lg="12" class="pb-0 pr-lg-10">
                        <b-textarea
                            to-mutate="adverse_event::adverse_event.pdf_data.description_summary"
                            :label="t('patients::adverse_event.form.label.description.summary')"
                            :readonly="readOnlyRules"
                            rows="5"
                            :mandatory="adverseEvent.event_type === 'other'"
                            :rules="
                                adverseEvent.event_type === 'other'
                                    ? [(v) => !!v || t('default::validation.field.required')]
                                    : []
                            "
                        ></b-textarea>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" lg="12" class="pb-0 pr-lg-10">
                        <v-col cols="12" class="pb-0">
                            <h5>{{ t('patients::adverse_event.form.title.details') }}</h5>
                        </v-col>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-date-picker-store
                            to-mutate="adverse_event::adverse_event.pdf_data.details_date_received"
                            :label="t('patients::adverse_event.form.label.details.date_received')"
                            :rules="validationRules.details_date_received"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-date-picker-store>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-date-picker-store
                            to-mutate="adverse_event::adverse_event.pdf_data.details_date_processed"
                            :label="t('patients::adverse_event.form.label.details.date_processed')"
                            :rules="validationRules.details_date_processed"
                            :readonly="readOnlyRules"
                            mandatory
                        ></b-date-picker-store>
                    </v-col>
                </v-row>

                <v-row class="pb-6">
                    <v-col cols="12" lg="8" class="pb-0 pr-lg-10">
                        <b-input
                            to-mutate="adverse_event::adverse_event.pdf_data.details_signature"
                            :label="t('patients::adverse_event.form.label.details.signature')"
                            :readonly="readOnlyRules"
                        ></b-input>
                    </v-col>
                    <v-col cols="12" lg="4" class="pb-0 pr-lg-10">
                        <b-date-picker-store
                            to-mutate="adverse_event::adverse_event.pdf_data.details_date"
                            :label="t('patients::adverse_event.form.label.details.date')"
                            :rules="validationRules.details_date"
                            :readonly="readOnlyRules"
                        ></b-date-picker-store>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="justify-content-start d-flex py-4">
                        <v-btn rounded text color="primary" @click="goBack()">
                            {{ t('patients::button.cancel') }}
                        </v-btn>

                        <v-btn
                            v-if="
                                can('api.v1.patients.blood-results.update') ||
                                can('api.v1.patients.blood-results.store')
                            "
                            :disabled="adverseEvent.id === 'new' || !can('api.v1.patients.adverse-events.update')"
                            :loading="adverseEventFormLoading"
                            color="primary"
                            rounded
                            class="ml-4"
                            @click="saveAdverseEvent()"
                        >
                            {{ t('patients::adverse_event.button.save_and_download') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-col>
    </div>
</template>

<script>
export default {
    data() {
        return {
            adverseEventForm: false,
            adverseEventFormLoading: false,
            adverseEventDetailsForm: false,
            validationRules: {
                adverse_event_type: [(v) => !!v || t('default::validation.field.required')],
                reporter_name: [(v) => !!v || t('default::validation.field.required')],
                reporter_address: [(v) => !!v || t('default::validation.field.required')],
                reporter_type: [(v) => !!v || t('default::validation.field.required')],
                patient_initials: [(v) => !!v || t('default::validation.field.required')],
                patient_dob: [(v) => !!v || t('default::validation.field.required')],
                patient_gender: [(v) => !!v || t('default::validation.field.required')],
                patient_dms_id: [(v) => !!v || t('default::validation.field.required')],
                patient_age: [(v) => !!v || t('default::validation.field.required')],
                company_product: [(v) => !!v || t('default::validation.field.required')],
                company_product_taken: [(v) => !!v || t('default::validation.field.required')],
                company_suspected_as_possible_cause_of_events: [(v) => !!v || t('default::validation.field.required')],
                company_indication_diagnosis: [(v) => !!v || t('default::validation.field.required')],
                company_dose_route: [(v) => !!v || t('default::validation.field.required')],
                adverse_event_date_event_started: [(v) => !!v || t('default::validation.field.required')],
                adverse_event_date_event_stopped: [(v) => !!v || t('default::validation.field.required')],
                adverse_event_seriousness: [(v) => !!v || t('default::validation.field.required')],
                adverse_event_seriousness_criteria: [(v) => !!v || t('default::validation.field.required')],
                adverse_event_treatment_required: [(v) => !!v || t('default::validation.field.required')],
                description_decreased_white_blood_cell_count_of_value: [],
                description_decreased_white_blood_cell_count_of: [],
                description_decreased_neutrophil_count_of: [],
                description_decreased_neutrophil_count_of_value: [],
                details_date_received: [(v) => !!v || t('default::validation.field.required')],
                details_date_processed: [(v) => !!v || t('default::validation.field.required')],
            },
            genderSelectItems: [
                { text: 'Male', value: 'male' },
                { text: 'Female', value: 'female' },
                { text: 'Other', value: 'other' },
            ],
            reportersTypeSelectItems: [],
            seriousnessCriteriaSelectItems: [],
            treatmentSelectItems: [],
            adverseEventTypesSelectItems: [],
        };
    },
    computed: {
        readOnlyRules() {
            if (this.adverseEvent.id === 'new') {
                return true;
            }
            return (
                (!this.can('api.v1.patients.adverse-events.update') ||
                    !this.can('api.v1.patients.adverse-events.store')) &&
                this.can('api.v1.patients.adverse-events.show')
            );
        },

        patient() {
            return this.$store.state.patients.patient;
        },
        patientId() {
            return this.$store.state.patients.patient.id;
        },
        adverseEvent() {
            return this.$store.state.adverse_event.adverse_event;
        },
    },

    mounted() {
        this.loadOptions();
    },

    methods: {
        async createAdverseEvent() {
            const data = {
                blood_result_id: this.adverseEvent.blood_result_id,
                event_type: this.adverseEvent.event_type,
            };
            if (!data.blood_result_id && !data.event_type) {
                return;
            }
            return await axios
                .post(
                    route('api.v1.patients.adverse-events.store', {
                        patient: this.patientId,
                        ...data,
                    })
                )
                .then((response) => {
                    this.$root.notify(
                        'info',
                        t('patients::adverse_event.form.success.created.title'),
                        t('patients::adverse_event.form.success.created.message')
                    );
                    this.$store.dispatch('adverse_event/loadAdverseEvent', {
                        patient_id: response.data.data.patient_id,
                        id: response.data.data.id,
                    });
                    this.$store.dispatch('patients/reloadPatientData');
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('adverse_event/setErrorMessages', error.response.data.errors);
                        this.scrollToError();
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                });
        },
        async loadOptions() {
            return await axios.get(route('api.v1.adverse-events.config')).then((response) => {
                const data = _.clone(response.data.adverse_events);
                this.reportersTypeSelectItems = data.reporter_types;
                this.seriousnessCriteriaSelectItems = data.seriousness_criteria;
                this.treatmentSelectItems = data.treatment_required;
                this.adverseEventTypesSelectItems = data.adverse_event_types;
            });
        },
        async saveAdverseEvent() {
            this.adverseEventFormLoading = true;
            this.$store.dispatch('adverse_event/resetErrorMessages');
            const data = this._.clone(this.adverseEvent);
            delete data.blood_result_id;
            return await axios
                .put(
                    route('api.v1.patients.adverse-events.update', {
                        patient: this.patientId,
                        adverse_event: this.adverseEvent.id,
                    }),
                    data
                )
                .then((response) => {
                    this.$root.notify(
                        'info',
                        t('patients::adverse_event.form.success.updated.title'),
                        t('patients::adverse_event.form.success.updated.message')
                    );
                    this.$store.dispatch('patients/reloadPatientData');
                    return axios
                        .get(route('adverse-events.download', { pdf: response.data.data.id }))
                        .then((response) => {
                            const link = document.createElement('a');
                            link.href = response.request.responseURL;
                            document.body.appendChild(link);
                            link.click();
                            _.delay(() => {
                                this.goBack();
                            }, 500);
                        })
                        .catch((error) => {
                            this.$root.notify('error', error.response.data.error);
                        });
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('adverse_event/setErrorMessages', error.response.data.errors);
                        this.scrollToError();
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => _.delay(() => (this.adverseEventFormLoading = false), 400));
        },
        scrollToError() {
            const element = this.$el.querySelector('.v-messages__message');
            if (!element) {
                return;
            }
            const offset = 50;
            const headerOffset = document.querySelector('.v-app-bar').offsetHeight + offset;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        },
        goBack() {
            this.$store.dispatch('adverse_event/resetForm');
            this.$store.dispatch('adverse_event/resetErrorMessages');
            this.$store.dispatch('patients/changeTab', 6);
        },
    },
};
</script>
<style scoped></style>
